import { Anchor, Flex, Text } from '@mantine/core';
import { NavLink } from 'react-router';

type VacancyBreadcrumbsProps = {
  subPage: string;
};

export const VacancyBreadcrumbs = ({ subPage }: VacancyBreadcrumbsProps) => (
  <Flex gap={4} wrap='nowrap'>
    <Anchor to='/vacancy-list' component={NavLink} variant='gray'>
      Вакансии
    </Anchor>
    <Text>/</Text>
    <Text c='tertiary.4' truncate='end' maw='50dvw'>
      {subPage}
    </Text>
  </Flex>
);
